import React from 'react';
/**
 * data Columns for grid and mobile view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Data Columns Array
 */
export const DataColumns = ({
  editContentSlider,
  GridFlag,
  BooleanValuesFilterCell,
  MultiViewCalenderFilterCell,
  dateRangeFilter,
  GridDateCell,
  setDateRangeFilter,
}) => {
  const dataColumns = [
    {
      field: 'uc_ossi_run_ord',
      title: 'Item Order',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
      cell: (props) => (
        <td
          className='edit-link'
          onClick={() => {
            editContentSlider(props.dataItem);
          }}
        >
          {'Step ' + props.dataItem.uc_ossi_run_ord}
        </td>
      ),
    },
    {
      field: 'uc_ossi_run_seq',
      title: 'Run Sequence',
      editable: false,
      show: false,
      width: '250px',
      minResizableWidth: 50,
      excludeFromFilter: true,
    },
    {
      field: 'tenant_name',
      title: 'Tenant',
      editable: false,
      show: false,
      width: '250px',
      width: '250px',
      minResizableWidth: 150,
      filterable: false,
      excludeFromFilter: true,
    },
    {
      field: 'uc_ossi_app_test_id',
      title: 'Test Id',
      editable: false,
      show: true,
      width: '250px',
      width: '250px',
      minResizableWidth: 50,
    },
    {
      field: 'uc_ossi_test_case_id',
      title: 'Test Case Id',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
    },
    {
      field: 'uc_ossi_user_cnt',
      title: 'No Of Concurrent UserDetail',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
    },
    {
      field: 'uc_ossi_step_run_till_expr',
      title: 'Run While Condition Is True',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
      filterable: false,
    },
    {
      field: 'uc_ossi_disable_flg',
      title: 'Disabled',
      editable: false,
      show: true,
      width: '150px',
      minResizableWidth: 50,
      cell: GridFlag,
      filterCell: BooleanValuesFilterCell,
    },
    {
      field: 'uc_ossi_descr',
      title: 'Description',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
    },
    {
      field: 'ins_user_id',
      title: 'Created By',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'ins_dt',
      title: 'Created Date',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'ins_dt',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
    {
      field: 'last_upd_user_id',
      title: 'Modified By',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'last_upd_dt',
      title: 'Modified Date',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'last_upd_dt',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
  ];

  return dataColumns;
};
export default DataColumns;
